import React from 'react'
import DashboardSectionCard from '@components/pages/Dashboard/DashboardSectionCard.component'
import DashboardSharedTable from '@components/pages/Dashboard/Shared/DashboardSharedTable'
import { huddleLeaderboardHasData } from '@utils/dashboardHuddle.util'
import {
  isDashboardSectionPending,
  shouldShowDashboardSectionEmpty,
} from '@utils/dashboardSectionEmpty.util'
import type { HuddleDashboard } from '../useHuddleDashboard'
import { HUDDLE_LEADERBOARD_COLUMNS } from '../huddleLeaderboard.constants'

type LeaderboardCardProps = {
  titleHref: string
  leaderboard: HuddleDashboard['leaderboardApi']
  className?: string
}

export function LeaderboardCard({
  titleHref,
  leaderboard,
  className = 'dashboard-huddle-leaderboard-card',
}: LeaderboardCardProps): React.ReactElement {
  const { cardRows, loading, data } = leaderboard
  const isEmpty = shouldShowDashboardSectionEmpty(
    loading,
    huddleLeaderboardHasData(data),
  )
  const pending = isDashboardSectionPending(loading, data != null)

  return (
    <DashboardSectionCard
      title="Leaderboard"
      titleHref={titleHref}
      className={className}
      loading={pending}
      skeleton={{ block: 'tall' }}
      isEmpty={isEmpty}
    >
      <div className="dashboard-huddle-leaderboard-table-wrap">
        <DashboardSharedTable
          loading={loading}
          showSearchFilter={false}
          columns={HUDDLE_LEADERBOARD_COLUMNS}
          data={cardRows}
          showPagination={false}
        />
      </div>
    </DashboardSectionCard>
  )
}
